import numeral from 'numeral';
import moment from 'moment';
//Configurando o formato numerico para portugues do brasil
numeral.register('locale', 'pt-br', {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'milhões',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function () {
    return 'º';
  },
  currency: {
    symbol: 'R$'
  }
});
numeral.locale('pt-br');

moment.locale('pt-br');

class Util {
  static formataMoeda(valor) {
    return numeral(valor).format('0,0.00');
  }

  static getDatePattern() {
    return /^[0-9]{4}-(0?[0-9]|1[0-2])-([0-2][0-9]|3[0-1])$/;
  }

  static getDateTimePattern() {
    return /^[0-9]{4}-(0?[0-9]|1[0-2])-([0-2][0-9]|3[0-1])(T| )[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/;
  }

  static getDateTimeZonePattern() {
    return /^[0-9]{4}-(0?[0-9]|1[0-2])-([0-2][0-9]|3[0-1])(T| )[0-2][0-9]:[0-5][0-9]:[0-5][0-9].*$/;
  }

  static parseDate(dateString) {
    if (Util.getDatePattern().test(dateString)) {
      return new Date(dateString + 'T00:00:00.000-03:00');
    } else if (Util.getDateTimePattern().test(dateString)) {
      return new Date(dateString += '-03:00');
    } else if (Util.getDateTimeZonePattern().test(dateString)) {
      return new Date(dateString);
    }
  }

  static formataData(data) {
    if (moment(data).isValid()) {
      return moment(data).format('DD/MM/YYYY');
    } else {
      return '';
    }
  }

  static formataDataHora(data) {
    if (moment(data).isValid()) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss');
    } else {
      return '';
    }
  }

  static getPrimeiroDiaAno(ano) {
    let primeiroDia = moment().startOf('year');
    if (typeof ano !== 'undefined') {
      return primeiroDia.year(ano);
    }
    return primeiroDia;
  }

  static getUltimoDiaAno(ano) {
    let ultimoDia = moment().endOf('year');
    if (typeof ano !== 'undefined') {
      return ultimoDia.year(ano);
    }
    return ultimoDia;
  }

  static getPropriedade(fn, mensagem) {
    try {
      let resultado = fn();
      if (typeof resultado === 'undefined' || (typeof resultado === 'string' && resultado.length === 0)) {
        throw new TypeError(resultado);
      }
      return resultado;
    } catch (e) {
      return typeof mensagem !== 'undefined' ? mensagem : 'Não Informado';
    }
  }
}

export default Util;


// WEBPACK FOOTER //
// ./src/modulos/Util.js